import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from "@mui/material";
import Modal from 'react-modal';
import CryptoJS from 'crypto-js';
import getCookie from '../../hooks/getCookie';

Modal.setAppElement('#root');

function Manutencao() {
  const navigate = useNavigate();
  const nameComplete = getCookie("nome_completo");

  useEffect(() => {
    if (nameComplete != null) {
    } else {
      navigate('/')
    }
  }, []);


  return (
    <Box sx={{ position: 'relative', backgroundColor: "#111", height: '100vh', overflow: 'hidden' }} className='container-manutencao'>
      <div class="squares">
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
        <div class="square"></div>
      </div>
      <div className='div-manutencao'>
        <div class="gearbox">
          <div class="overlay"></div>
          <div class="gear one">
            <div class="gear-inner">
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </div>
          </div>
          <div class="gear two">
            <div class="gear-inner">
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </div>
          </div>
          <div class="gear three">
            <div class="gear-inner">
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </div>
          </div>
          <div class="gear four large">
            <div class="gear-inner">
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
              <div class="bar"></div>
            </div>
          </div>
        </div>
        <div className='manutencao-texto'>
          <Typography className='titulo-manutencao'>Oops! Sistema em Manutenção</Typography>
          <Typography className='texto-manutencao'>Desculpe pelo transtorno.</Typography>
          <Typography className='texto-manutencao'>Estamos trabalhando para o <b className='texto-verde'>melhor desempenho do sistema!</b></Typography>
        </div>
      </div>
    </Box>
  );
}

export default Manutencao;